export class Constants {
  public static readonly feedbackPrefix = "FWD Dashboard - Feedback";

  public static readonly feedbackEmail = "info@fahrwegdiagnose.ch";

  public static readonly feedbackTemplate = (
    email: string,
    description: string,
    numberOfFiles: number | undefined
  ) => {
    return `
    <div>
      <p>Sehr geehrtes FahrwegDiagnose Team,</p>
      <p>Der User <b>${email}</b> hat ein Feedback zum FahrwegDiagnose Dashboard hinterlassen:
          <p><b>${description}</b></p> 
      </p>
    
      <p>Dem Feedback beiliegende Bilder: <b>${
        numberOfFiles ? numberOfFiles : "0"
      }</b></p>
    
      <p>Freundliche Grüsse</p>
       <p>FahrwegDiagnose Dashboard</p>
    </div>`;
  };
}
